export enum Size {
  EXTRA_SMALL = 'xs',
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
  EXTRA_LARGE = 'xl',
}

export type SizeExtraSmall = 'xs';
export type SizeSmall = 'sm';
export type SizeMedium = 'md';
export type SizeLarge = 'lg';
export type SizeExtraLarge = 'xl';
